import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'
import axios from "@/libs/axios";

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'tenants.title',
      key: 'tenant.name',
      sortable: false
    },
    {
      label: 'Timezone',
      key: 'timezone.name',
      sortable: false
    },
    {
      label: 'custom_timezones.name',
      key: 'name',
      sortable: false
    },
    {
      label: 'custom_timezones.start',
      key: 'start_dst_formated',
      sortable: false
    },
    {
      label: 'custom_timezones.end',
      key: 'end_dst_formated',
      sortable: false
    }
  ]

  if (ability.can('update', 'Providers') || ability.can('delete', 'Providers')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('name')
  const isSortDirDesc = ref(false)
  const timezoneOptions = ref([]);

  store.dispatch('tenant/getAll')

  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems'])

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    axios.get('v1/custom-timezones', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value
    })
      .then(response => {
        callback(response.data.data)
        totalList.value = response.data.meta.total
      })
      .catch((error) => {
        console.log('error', error);
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const getTimezones = () => {
    axios.get('v1/timezone')
      .then(response => {
        const { data } = response;

        timezoneOptions.value = data.data;
      })
      .catch(() => {
        timezoneOptions.value = [];
      })
  }


  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      /* code: eventCodeFilter.value,
      id_type_alarm: typeAlarmFilter.value,
      dispatch_alarm: dispatchAlarmFilter.value, */
    }
    refetchData()
  }

  const clearSearchFilters = () => {
    /* eventCodeFilter.value = null
    typeAlarmFilter.value = null
    dispatchAlarmFilter.value = null */
    buildFilters()
  }

  getTimezones();

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    refetchData,
    tenantOptions,
    timezoneOptions
  }
}
